import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';

function BreadcrumbMenu({items}) {
  if(items) {
    return (
      <>
        <Breadcrumb className='breadcrumb'>
          {items.map((item, index) => (
            item.activePage) ?
              (<Breadcrumb.Item active key={index} style={{color : "#000000"}}>{item.caption}</Breadcrumb.Item>)
             : (<Breadcrumb.Item key={`bm_${index}`}><Link to={item.link}>{item.caption}</Link></Breadcrumb.Item>)
          )}
        </Breadcrumb>
      </>
    );
  } else {
    return null;
  }
  
}

export default BreadcrumbMenu;